.ring {
  position: relative;
  flex: none;
  background: var(--color-surface);
  border-radius: 50%;
  box-shadow: var(--shadow-lg);
}
.svg {
  position: absolute;
  inset: 0;
}
.track {
  stroke: var(--color-neutral-200);
}
.progress {
  transition: stroke-dashoffset 0.1s linear;
}
.warning {
  stroke: var(--color-warning);
}
.danger {
  stroke: var(--color-danger);
}
.content {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
